<template>
    <div>
        <MobileFetchData :transactions="transactions" :isMobile="isMobile" @showModal="showModal"></MobileFetchData>
        <div class="row" style="padding-left:15px;padding-right:15px;" v-for="item in transactions" :key="item.rowId" @click="showModal(item)" v-if="isMobile">
           <div class="col-md-12 content-content" style="padding:0">
                <div class="content-content-inner col-md-12">
                    <div class="col-item-zero flex j-center">
                        <p class="shape-3" :class="item.transactionType | typeClass(item.transactionType,item.isPartnerTransaction)"></p>
                    </div>
                    <div class="col-item-one flex j-center">
                        <span>{{item.billDate|date}}</span>
                    </div>
                    <div class="col-item-two flex j-center">
                        <span class="text-center">{{item.storeName}}</span>
                    </div>
                    <div class="col-item-three flex align-center j-center" v-if="!memberActivePoint" :class="[item.addedBonus != 0 ? 'add-number' : '']">
                          {{add(item.addedBonus)}} 
                    </div>
                    <div class="col-item-four flex align-center j-center" v-if="!memberActivePoint" :class="[item.usedBonus != 0 ? 'minus-number' : '']">
                        {{minus(item.usedBonus)}} 
                    </div>
                    <div class="col-item-five flex align-center j-center" v-if="memberActivePoint" :class="[item.addedUPoint != 0 ? 'add-number' : '']">
                         {{add(item.addedUPoint)}} 
                    </div>
                    <div class="col-item-six flex align-center j-center">
                        {{item.totalAmount | pricewithindex}}
                    </div>
                    <div class="col-item-seven flex align-center j-end" style="flex:1;">
                        <span>{{item.cardHolderInfId}}</span>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
import MobileFetchData from './MobileFetchData'
    export default {
        props:['transactions','memberActivePoint'],
        data(){
            return {
                isMobile:true,
                windowWidth: 0,
                windowHeight: 0,
            }
        },
        methods:{
            showModal(value){
                this.$emit('openModal',value);
            },
            getWindowWidth() {
                this.windowWidth = document.documentElement.clientWidth;
                if(this.windowWidth <= 767){
                    this.isMobile = false;
                }else{
                    this.isMobile = true;
                }
            },
            minus(value){
                if(value != 0){
                    let add_value  = this.changeNumber(value);
                    return  '-' + add_value;
                }else{
                    return value;
                }
            },
            add(value){
                if(value != 0){
                    let add_value  = this.changeNumber(value);
                    return  '+' + add_value;
                }else{
                    return value;
                }
            },
            changeNumber(value){
                if(value > 0){
                    var converted = value.toString();
                    var position = converted.indexOf(".");
                    if(position > '0'){
                        var returned_value = converted.substring(0, position);
                        return Number(returned_value).toLocaleString();
                    }
                    return Number(value).toLocaleString();
                }
                return Number(value).toLocaleString();
            }
        },
        created() {
          this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth()
          })

        },
        beforeDestroy() {
          window.removeEventListener('resize', this.getWindowWidth);
        },
        components:{
            MobileFetchData
        }
    }
</script>

<style scoped>
.mobile-content-item{
    margin-top:20px;
    padding-left: 20px;
    padding-right: 13px;
    padding-top:24px;
    width:100%;
    height: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    box-shadow: 0px 1px 1px 0 rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
}
.mobile-content-header{
    margin-bottom:13px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    border-bottom:1px dotted rgba(0, 0, 0, 0.1);
}
.mobile-content-header div:nth-child(1){
    flex:1;
}
.mobile-content-header div:nth-child(1) p{
    margin-bottom:4px;
    opacity: 0.6;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
}
.mobile-content-header div:nth-child(2) p{
    margin:0;
    opacity: 0.6;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: right;
    color: rgba(0, 0, 0, 0.6);
}
.mobile-content-body{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    opacity: 0.5;
    border-radius: 3px;
    background-color: #f5f5f5;
}
.mobile-content-body div{
    width:50%
}
.mobile-content-body div:nth-child(1) p,.mobile-content-body div:nth-child(3) p{
    opacity: 0.8;
    font-size: 13px;
    padding-top:14px;
    padding-left:18px;
    padding-bottom:13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: rgba(0, 0, 0, 0.8);
    margin:0;
}
.mobile-content-body div:nth-child(3) p{
    padding-top:0;
}
.mobile-content-body div:nth-child(2) p,.mobile-content-body div:nth-child(4) p{
    padding-right: 11px;
    padding-top:15px;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: right;
    color: #000000;
    margin:0;
}
.mobile-content-body div:nth-child(4) p{
    padding-top:0;
}
.mobile-content-footer{
    display: flex;
    flex-direction: column;
    border-bottom:1px dotted rgba(0, 0, 0, 0.1);
}
.mobile-content-footer p{
    width:100%;
    margin-bottom:0;
    display: flex;
    justify-content: flex-end;
}
.mobile-content-footer p:nth-child(1){
    margin-top:12px;
    opacity: 0.6;
    font-size: 10px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: right;
    color: rgba(0, 0, 0, 0.6);
    text-transform: uppercase;
}
.mobile-content-footer p:nth-child(2){
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: right;
    color: #1660ab;
    margin-bottom:28px!important;
}
</style>